import { render, staticRenderFns } from "./LessonDetail.vue?vue&type=template&id=6e899740&scoped=true&"
import script from "./LessonDetail.vue?vue&type=script&lang=ts&"
export * from "./LessonDetail.vue?vue&type=script&lang=ts&"
import style0 from "./LessonDetail.vue?vue&type=style&index=0&id=6e899740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e899740",
  null
  
)

export default component.exports